import { getErrorMessage } from 'utils/stringUtils';

import { types } from './actions';

const initialState = {
  success: null,
  error: null,
  isFetching: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_PASSWORD_REQUEST:
      return { success: null, error: null, isFetching: true };
    case types.RESET_PASSWORD_SUCCESS:
      return { ...state, success: action.payload.message, isFetching: false };
    case types.RESET_PASSWORD_ERROR:
      return {
        ...state,
        error: getErrorMessage(action.payload),
        isFetching: false,
      };
    default:
      return state;
  }
};

export default reducer;
